import { FormFieldModel, FormFieldValidator } from '@alfresco/adf-core';

export class DokumentenVerteilungValidator implements FormFieldValidator {
  isSupported(field: FormFieldModel): boolean {
    return field.id === 'documentDistribution';
  }

  validate(field: FormFieldModel): boolean {


    let isValid = true;
    if (this.isSupported(field) && field.value != null) {
      const entries: [key: string][] = field.value;
      if (entries.length == 0) {
        isValid = false;
      } else {
        const invalidKeys: string[] = [
          'DOKUMENTEN-VERTEILUNG.VERTEILUNG.MATRIX.ORGANISATIONSROLLE',
          'DOKUMENTEN-VERTEILUNG.VERTEILUNG.MATRIX.ABLAGE-BOKUDMS',
        ];

        // ALF-1373 the entries have to contain more keys than only the keys given in invalidKeys
        isValid = entries.every((entry) => {
          const entryKeys = Object.keys(entry);
          const validKeys = entryKeys.filter( ( el ) => !invalidKeys.includes( el ) );
          return validKeys.length > 0;
        });
      }

      if (!isValid) {
        field.validationSummary.message = 'DOKUMENTEN-VERTEILUNG.VERTEILUNG.MATRIX.KEINE-ROLLEN';
        field.validationSummary.attributes = new Map<string, string>();
        field.validationSummary.attributes.set('fieldname', field.name);
        return false;
      }
    }
    return true;
  }
}
